export enum Like {
  M = 1,
  N,
  X,
}
